import React from "react";
import { Flex } from "../src/index";

const Section = ({ children }) => {
  return (
    <Flex direction="column" className={"Section"}>
      {children}
    </Flex>
  );
};
export default Section;
